<template>
  <main class="main inside-page cabinet-page profile-page">
    <div class="section profile-section">
      <div class="wrapper">
        <div class="left">
          <div class="left-wrapper">
            <div class="user">
              <img class="user" src="../images/user2.svg" />
              <div class="title small">
                {{ profile.name }}
              </div>

              <label class="label">
                <div class="desc desc-12">
                  <img class="img" src="../images/at.svg" />
                  <b>{{ $t("Email") }}:</b>
                </div>
                <input disabled type="email" name="email" v-model="email" />
              </label>
              <label class="label">
                <div class="desc desc-12">
                  <img class="img" src="../images/mobile-notch.svg" />
                  <b>{{ $t("Phone number") }}:</b>
                </div>
                <input type="text" disabled name="phone" v-model="phone" />
              </label>
              <div class="buttons">
                <button
                  class="button colored"
                  @click="$parent.openPersonalInfoModal"
                >
                  <img src="@/images/edit.svg" />
                  <span>{{ $t("Edit profile") }}</span>
                </button>
                <div @click="logOut" class="button bordered-white">
                  <span>{{ $t("Log out") }}</span>
                </div>
              </div>
            </div>
            <div class="balance">
              <img class="balance-icon" src="../images/balance.svg" />
              <div class="flex">
                <div class="desc desc-12">{{ $t("Current balance") }}:</div>
                <div class="desc small">
                  <b>{{ formatPoints(profile.balance) }}</b>
                  <img class="coin" src="../images/coin.svg" />
                </div>
              </div>
              <button class="button bordered-white" @click="openTopUpModal">
                <img class="add" src="../images/add.svg" />
                {{ $t("Top up balance") }}
              </button>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="right-wrapper">
            <div class="offers">
              <div class="title small">{{ $t("Special offers") }}</div>
              <div class="flex">
                <div class="offers-left">
                  <div class="title title-16">{{ $t("Buy Bundle") }}</div>
                  <div class="list">
                    <div
                      v-for="{ id, price, points } in bundles()"
                      :key="id"
                      class="item"
                    >
                      <div class="coins">
                        <div class="desc small">
                          <b>{{ formatPoints(points, false) }}</b>
                        </div>
                        <img class="coin" src="../images/coin.svg" />
                      </div>
                      <div class="item-right">
                        <div class="desc desc-18">
                          <b>{{ price }} €</b>
                        </div>
                        <button
                          @click="choiceBundle(id)"
                          class="button bordered-white"
                        >
                          {{ $t("Buy") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="offers-right">
                  <div class="title title-16">
                    {{ $t("Buy Channel Status") }}
                  </div>
                  <div class="flex">
                    <div class="offers-right-get">
                      <div class="desc small">
                        <b>{{ $t("You will get") }}:</b>
                      </div>
                      <div class="list">
                        <div class="item desc small">
                          {{ $t("Topics Highlight") }}
                        </div>
                        <div class="item desc small">
                          {{ $t("Ability to change topics name colour") }}
                        </div>
                        <div class="item desc small">
                          {{
                            $t("Create up to 5 topics at once (1 per device)")
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="offers-right-price">
                      <div class="desc small">
                        <b>{{ $t("Price") }}:</b>
                      </div>
                      <div class="subscribtions">
                        <div class="desc small">
                          <b>
                            {{
                              formatPoints(settings("channel_status_cost"))
                            }}</b
                          >
                          <img class="coin" src="../images/coin.svg" />
                        </div>
                        <div class="desc small">
                          {{ $t("/ per week") }}
                        </div>
                      </div>

                      <button
                        @click="buyChannelStatus"
                        class="button bordered-white"
                      >
                        {{ $t("Buy") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-wrapper">
            <div class="history">
              <div class="title small">{{ $t("Purchase History") }}</div>
              <div
                v-if="paymentHistory && !paymentHistory.length"
                class="desc no-istory"
              >
                {{ $t("No Purchase History") }}
              </div>
              <div
                class="profile-table"
                v-if="paymentHistory && paymentHistory.length"
              >
                <table>
                  <thead>
                    <tr>
                      <td class="desc desc-12">
                        <b>{{ $t("Date") }}</b>
                      </td>
                      <td class="desc desc-12">
                        <b>{{ $t("Purchase") }}</b>
                      </td>
                      <td class="desc desc-12">
                        <b>{{ $t("Price") }}</b>
                      </td>
                      <td class="desc desc-12">
                        <b>{{ $t("Points amount") }}</b>
                      </td>
                      <td class="desc desc-12">
                        <b>{{ $t("Status") }}</b>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="{
                        id,
                        sum,
                        created_at,
                        points,
                        status,
                      } in paymentHistory"
                      :key="id"
                    >
                      <td class="desc small">
                        {{ created_at | moment("D.MM.YYYY") }}
                      </td>
                      <td class="desc small">{{ $t("Balance top-up") }}</td>
                      <td class="desc small">{{ sum }} €</td>
                      <td class="desc small">{{ formatPoints(points) }}</td>
                      <td class="desc small">{{ status }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios from "@/axios";

export default {
  name: "Profile",
  props: [],
  data: function () {
    return {
      paymentHistory: [],
      uploadedDocument: null,
      uploadedImage: null,
    };
  },
  mounted() {
    this.getDepositHistory();
    this.getBundles();
  },
  watch: {},
  methods: {
    logOut() {
      const self = this;

      axios.post("logout").then(async ({ data }) => {
        if (data.status === "OK") {
          await self.logout({ pushToLogin: true });
        }
      });
    },
    choiceBundle(id) {
      this.SET_TOP_UP_BUNDLE_ID(id);
      this.$parent.openTopUpModal();
    },
    openTopUpModal() {
      this.SET_TOP_UP_BUNDLE_ID(null);
      this.$parent.openTopUpModal();
    },
    getDepositHistory() {
      const self = this;

      axios.get("deposit/history").then(({ data }) => {
        if (data.status === "OK") {
          self.paymentHistory = data.payload;
        }
      });
    },
    formatPoints(pts, big = true) {
      if (pts >= 1000000) {
        return (pts / 1000000).toFixed(1) + (big ? "M" : "m");
      } else if (pts >= 1000) {
        return (pts / 1000).toFixed(1) + (big ? "K" : "k");
      } else {
        return pts;
      }
    },
    async buyChannelStatus() {
      const self = this;

      this.showConfirmationModal(
        this.$t("Are you sure you want to buy channel status ?")
      ).then(() => {
        axios
          .post("user/become-channel")
          .then(({ data }) => {
            if (data.status === "OK") {
              self.SET_BALANCE(data.payload.balance);
              self.SET_IS_CHANNEL(true);
              self.SET_CHANNEL_EXPIRE_AT(data.payload.channel_status_due_date);
              const endDate = this.$moment(
                data.payload.channel_status_due_date
              ).format("DD/MM/YYYY");
              self.showNotification({
                text: this.$t(
                  `You successfully purchased channel status for 1 week, which ends on {endDate}`,
                  { endDate }
                ),
              });
            } else if (data.status === "ERROR") {
              self.showNotification({ text: data.message });
            }
          })
          .catch(({ response }) => {
            if (response.status === 400) {
              if (response.data.message) {
                self.showNotification({ text: response.data.message });
              }
            }
          });
      });
    },
    ...mapActions("app", [
      "getBundles",
      "showNotification",
      "showConfirmationModal",
    ]),
    ...mapMutations("app", ["SET_TOP_UP_BUNDLE_ID"]),
    ...mapActions("user", ["logout"]),
    ...mapMutations("user", [
      "SET_BALANCE",
      "SET_IS_CHANNEL",
      "SET_CHANNEL_EXPIRE_AT",
    ]),
  },
  computed: {
    phone() {
      return this.profile.phone;
    },

    email() {
      return this.profile.email;
    },
    ...mapGetters("user", ["profile", "channelExpireAt"]),
    ...mapGetters("app", ["settings", "bundles"]),
    balance() {
      if (this.profile.balance >= 1000) {
        return (this.profile.balance / 1000).toFixed(1) + "K ";
      } else {
        return this.profile.balance;
      }
    },
  },
};
</script>
